export default __webpack_public_path__ + "static/media/netflix.ce3078b4.png";